import PropTypes from 'prop-types';
import { Marker } from 'react-leaflet';

// This exists in order to extend react-Leaflet's Marker component,
// which allows us access to the underlying leaflet element.

export default class MapMarker extends Marker {
  static propTypes = {
    ...Marker.propTypes,
    isPopupOpen: PropTypes.bool,
  }

  componentWillReceiveProps(nextProps) {
    super.componentWillReceiveProps(nextProps);

    if (!this.props.isPopupOpen && nextProps.isPopupOpen) {
      this.leafletElement.openPopup();
    } else if (this.props.isPopupOpen && !nextProps.isPopupOpen) {
      this.leafletElement.closePopup();
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Map/MapMarker.js